import PropTypes from 'prop-types';

export default PropTypes.shape({
  showMeterRegwall: PropTypes.bool,
  treatmentVariant: PropTypes.string,
  meterRemaining: PropTypes.string,
  modalToRender: PropTypes.node,
  isMeteredPremium: PropTypes.bool,
});
